import { countriesObj } from '../data/countries'

const buildCountriesOptions = () => {
  return Object.keys(countriesObj).map((key) => ({
    value: key,
    label: countriesObj[key]
  }))
}

const europeanISO3Codes = new Set([
  'ALB',
  'AND',
  'AUT',
  'BLR',
  'BEL',
  'BIH',
  'BGR',
  'HRV',
  'CYP',
  'CZE',
  'DNK',
  'EST',
  'FIN',
  'FRA',
  'DEU',
  'GRC',
  'HUN',
  'ISL',
  'IRL',
  'ITA',
  'LVA',
  'LIE',
  'LTU',
  'LUX',
  'MLT',
  'MDA',
  'MCO',
  'MNE',
  'NLD',
  'MKD',
  'NOR',
  'POL',
  'PRT',
  'ROU',
  'RUS',
  'SMR',
  'SRB',
  'SVK',
  'SVN',
  'ESP',
  'SWE',
  'CHE',
  'UKR',
  'GBR',
  'VAT'
])

const isEuropeanCountry = (iso3) => {
  return iso3 && europeanISO3Codes.has(iso3.toUpperCase())
}

export { buildCountriesOptions, isEuropeanCountry }
